import { defineMessages } from 'react-intl';

export const NavCardMessages = defineMessages({
  jettingCalculatorTitle: {
    id: 'NavCard.jettingCalculatorTitle',
    defaultMessage: 'Jetting Calculator',
    description: 'Title for a link that takes user to a tool that helps them configure their jetting device.',
  },
  jettingCalculatorSubtitle: {
    id: 'NavCard.jettingCalculatorSubtitle',
    defaultMessage: 'Planning Tools',
    description: 'Subtitle for a link that takes user to a tool that helps them configure their jetting device.',
  },
  productInformationTitle: {
    id: 'NavCard.productInformationTitle',
    defaultMessage: 'Product Information',
    description: 'Title for link that takes user to a manuals page.',
  },
  productInformationSubtitle: {
    id: 'NavCard.productInformationSubtitle',
    defaultMessage: 'Resource Center',
    description: 'Subtitle for link that takes user to a manuals page.',
  },
  sentinelLinkTitle: {
    id: 'ResourceLink.sentinelLinkTitle',
    defaultMessage: 'Sentinel Link',
    description: 'Title for link that takes user to the Sentinel Link application.',
  },
  sentinelLinkSubtitle: {
    id: 'ResourceLink.sentinelLinkSubtitle',
    defaultMessage: 'App Sign In',
    description: 'Subtitle for link that takes user to the Sentinel Link application.',
  },
  stoneAgeTrainingTitle: {
    id: 'NavCard.stoneAgeTrainingTitle',
    defaultMessage: 'StoneAge Training',
    description: 'Title for link that takes user to the training courses',
  },
  stoneAgeTrainingSubtitle: {
    id: 'NavCard.stoneAgeTrainingSubtitle',
    defaultMessage: 'Available Courses',
    description: 'Subtitle for link that takes user to the training courses',
  },
  warthogSewerToolsTitle: {
    id: 'Generic.warthogSewerTools',
    defaultMessage: 'Warthog Sewer Tools',
    description: 'Title for link that takes user to the Warthog nozzles page',
  },
  warthogSewerToolsSubtitle: {
    id: 'ResourceLink.warthogSewerToolsSubtitle',
    defaultMessage: 'Products',
    description: 'Subtitle for link that takes user to the Warthog nozzles page',
  },
  waterblastToolsTitle: {
    id: 'Generic.waterblastTools',
    defaultMessage: 'Waterblast Tools',
    description: 'Title for link that takes user to the StoneAge products page',
  },
  waterblastToolsSubtitle: {
    id: 'ResourceLink.waterblastToolsSubtitle',
    defaultMessage: 'Products',
    description: 'Subtitle for link that takes user to the StoneAge products page',
  },
  yourAccountTitle: {
    id: 'NavCard.yourAccountTitle',
    defaultMessage: 'Your Account',
    description: 'Title for the Account resource',
  },
  yourAccountSubtitle: {
    id: 'NavCard.manageYourAccount',
    defaultMessage: 'Manage Settings',
    description: 'Subtitle for a link to navigate user to manage account page',
  },
  experienceFeedbackSuccess: {
    id: 'NavCard.experienceFeedbackSuccess',
    defaultMessage: 'Thanks for your feedback!',
  },
  supportFeedbackTitle: {
    id: 'Generic.supportFeedbackTitle',
    defaultMessage: 'How are we doing?',
  },
  supportFeedbackSubtitle: {
    id: 'Generic.supportFeedbackSubtitle',
    defaultMessage: 'We want to make SentinelLink the best possible experience.',
    description: 'Subtitle for a link that takes user to a feedback page',
  },
  supportFeedbackButtonLabel: {
    id: 'Generic.supportFeedbackButtonLabel',
    defaultMessage: 'Provide Feedback',
  },
  supportContactStoneAgeTitle: {
    id: 'Generic.supportContactStoneAgeTitle',
    defaultMessage: 'Contact StoneAge',
  },
  supportContactStoneAgeSubtitle: {
    id: 'Generic.supportContactStoneAgeSubtitle',
    defaultMessage: 'Our experienced support team is here to help.',
    description: 'Subtitle for a link that takes user to a contact page',
  },
});
